import { HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { RowToggler } from 'primeng/table';
import { BookingArriveByPod } from 'src/app/core/models/transport-operation/booking-arrive-by-pod';
import { ShippingDocumentService } from 'src/app/core/services/shipping-document.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { DeliveryOrderService } from '../../transport-operation/services/delivery-order.service';


@Component({
  selector: 'laas-dofile-pod-management',
  templateUrl: './dofile-pod-management.component.html',
  styleUrls: ['./dofile-pod-management.component.scss']
})
export class DofilePodManagementComponent extends SessionBaseComponent implements OnInit, OnChanges {
  @ViewChild('fileUploadByBooking') fileUploadByBooking!: FileUpload;
  @ViewChild('fileUploadByBookingDetail') fileUploadByBookingDetail!: FileUpload;
  @Input() bookingNo!: string;
  @Input() display!: boolean;
  @Input() fileType?: string;
  @Output() onClose = new EventEmitter<boolean>();

  documentOptions: any[];
  selectedDocument: string;
  podByBooking: any[];
  podByBookingDetail: any[];
  selectedBookingDetail: any;
  isLoading: boolean;
  selectedDoc: any;
  columns: any[];

  constructor(
    injector: Injector,
    private DOService: DeliveryOrderService,
    private shippingDocumentService: ShippingDocumentService
  ) {
    super(injector);
    this.documentOptions = [];
    this.selectedDocument = "";
    this.podByBooking = [];
    this.podByBookingDetail = [];
    this.selectedBookingDetail = "";
    this.isLoading = false;
    this.columns = [
      { field: 'facility', header: '倉別', sort: true },
      { field: 'doNo', header: this.translateService.instant('DeliveryOrder.DoNo'), sort: true },
      { field: 'version', header: '版本', sort: true },
      { field: 'createUser', header: '上傳人', sort: true },
      { field: 'updateDt', header: '最後更新時間', sort: true }
    ];
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let propertyName in changes) {
      if(propertyName == "bookingNo"){
        if(!isNullOrEmpty(this.bookingNo)){
          this.getDocOptions(true);
        }
      }
    }
  }

  getDocOptions(isLoadDocs: boolean): void{

    var fileType = this.fileType ?? "DeliveryOrder";

    this.shippingDocumentService.getDocumentOptions(this.laasSetting.language, this.bookingNo, fileType).subscribe({
      next: result => {
        this.documentOptions = result.filter((x: any) => x.value === 'ProofOfDelivery');
        this.translateService.get('Common.DropDown.Select')
        .subscribe({
          next: str => {
            this.documentOptions.unshift({
              text: str,
              value:""
            });
          }
        });

        this.selectedDocument = 'ProofOfDelivery';

        if(isLoadDocs){
          this.searchDocuments();
        }
      }
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  searchDocuments(): void{
    this.isLoading = true;

    this.shippingDocumentService.searchProofOfDelivery(this.bookingNo).subscribe({
      next: result => {
        this.podByBooking = result.podByBookingList;
        this.podByBookingDetail = result.podByBookingDetailList.map((x: any) => x);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  hideDialog(event:any): void{
    this.onClose.emit(this.display);
  }

  downloadChange(event:any, downloadObj: any){
    this.selectedDoc = downloadObj;
    var searchObj = {
      sn: this.selectedDoc.docId,
      version: this.selectedDoc.version
    };

    this.DOService.downloadFile(searchObj).subscribe(x => {
      var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

      let downloadURL = window.URL.createObjectURL(blob);
      let link = document.createElement('a');
      link.href = downloadURL;
      if (this.selectedDoc?.doNo === undefined){
        link.download = `ProofOfDelivery_${this.selectedDoc.bookingNo}.${this.selectedDoc.fileType}`; //瀏覽器下載時的檔案名稱
      }
      else{
        link.download = `ProofOfDelivery_${this.selectedDoc.doNo}.${this.selectedDoc.fileType}`;
      }
      link.click();
    });
  }

  deleteFile(event: any, deleteObj: any): void {
    this.shippingDocumentService.deleteFileBySnCode(deleteObj.docId).subscribe({
      next: result => {
        this.toastService.success(this.translateService.instant('BoookingSearch.Success.DeleteSuccess'), false);
        this.getDocOptions(true);
      },
      error: result => {
        this.toastService.error(this.translateService.instant('BoookingSearch.Error.DeleteFail'));
      }
    });
  }

  clearUploadUI(docReference: any): void{
    this.selectedDocument = "";
    if (docReference === 'Booking'){
      this.fileUploadByBooking.progress = 0;
      this.fileUploadByBooking.clear();
    }
    else if (docReference === 'DeliveryOrder'){
      this.fileUploadByBookingDetail.progress = 0;
      this.fileUploadByBookingDetail.clear();
    }
  }

  fileUploaderByBooking(event: any): void {

    if (this.selectedDocument === "") {
      this.toastService.warn(this.translateService.instant('BoookingSearch.Alert.FileType'), false);
      return;
    }

    let combinedJsonObj = {
      documentInfo: {
        docType: this.selectedDocument,
        docReference: {
          name: "Booking",
          key: this.bookingNo
        },
        remark: this.bookingNo,
        operatorName: encodeURI(this.userProfile.userName)
      },
      arriveRequests: this.podByBookingDetail.map(x => {
        return {
          bookingNo: this.bookingNo,
          doNo: x.doNo
        };
      })
    };

    this.isLoading = true;

    this.DOService.uploadAndArriveBooking(event.files[0], combinedJsonObj).subscribe({
      next: rsp => {
        if (rsp.type === HttpEventType.UploadProgress) {
          const percentDone = Math.round(100 * rsp.loaded / rsp.total);
          this.fileUploadByBooking.progress = percentDone;
        }
        if (rsp.type === HttpEventType.Response && rsp.status == 200) {
          this.toastService.success(this.translateService.instant('BoookingSearch.Success.Uploadsuccess'), false);
          this.getDocOptions(true);
        }
      },
      error: rsp => {
        this.toastService.error(this.translateService.instant('BoookingSearch.Success.UploadFail'));
      },
      complete: () => {
        this.clearUploadUI("Booking");
        this.isLoading = false;
      }
    });
  }

  fileUploaderByBookingDetail(event: any): void {

    if (this.selectedDocument === "") {
      this.toastService.warn(this.translateService.instant('BoookingSearch.Alert.FileType'), false);
      return;
    }
    if (this.selectedBookingDetail?.doNo === undefined) {
      this.toastService.warn(this.translateService.instant('BoookingSearch.Alert.SelectUploaded'), false);
      return;
    }

    let combinedJsonObj = {
      documentInfo: {
        docType: this.selectedDocument,
        docReference: {
          name: "DeliveryOrder",
          key: this.selectedBookingDetail.doNo
        },
        remark: this.bookingNo,
        operatorName: encodeURI(this.userProfile.userName)
      },
      arriveRequests: [
        {
          bookingNo: this.bookingNo,
          doNo: this.selectedBookingDetail.doNo
        }
      ]
    };

    this.isLoading = true;

    this.DOService.uploadAndArriveDetail(event.files[0], combinedJsonObj).subscribe({
      next: rsp => {
        if (rsp.type === HttpEventType.UploadProgress) {
          const percentDone = Math.round(100 * rsp.loaded / rsp.total);
          this.fileUploadByBookingDetail.progress = percentDone;
        }
        if (rsp.type === HttpEventType.Response && rsp.status == 200) {
          this.toastService.success(this.translateService.instant('BoookingSearch.Success.Uploadsuccess'), false);
          this.getDocOptions(true);
        }
      },
      error: rsp => {
        this.toastService.error(this.translateService.instant('BoookingSearch.Success.UploadFail'));
      },
      complete: () => {
        this.clearUploadUI("DeliveryOrder");
        this.isLoading = false;
      }
    });
  }

  getDialogTitle(): string{
    var title = "出貨單";
    switch(this.fileType){
      case "Booking":
        title = "Booking";
      break;
    }
    return title;
  }

  isShowIcon(detail: any): boolean{
    return detail.seqNo !== null;
  }
}
